import { BookDemoSection } from "@/components/home/book-demo/book-demo-section"
import { FooterSection } from "@/components/home/footer"

/**
 * Demo booking page.
 * Provides a dedicated page for users to request a product demo.
 */
export function DemoPage() {
  return (
    <>
      <BookDemoSection />
      <FooterSection />
    </>
  )
}
